module.exports = __webpack_public_path__ + "static/media/pic3.730fc4a2.png";